import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { ResponseContentType } from '@angular/http';
import * as moment from 'moment';
import { SemsoEncryptionModule } from './encryption/encryption.module';

@Injectable()
export class DownloadService {
  private pdfSubject = new Subject<any>();
  public pdf$ = this.pdfSubject.asObservable();

  constructor(
    private http: HttpClient,
    private encryption: SemsoEncryptionModule) { }

  public downloadWorkProcess(id, studentIdEncrypted) {
    this.http.get(`/kerntaken/${id}/pdf/gevuld/`, {
      responseType: 'blob'
    }).subscribe(data => {
      var studentId = this.encryption.decrypt(studentIdEncrypted);
      this.pdfSubject.next({
        data: new Blob([data], { type: 'application/octet-stream' }),
        name: `${studentId}_${id}_${moment(new Date()).format('YYYYMMDD_HHmmss')}.pdf`
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/download.service.ts